<template><!-- header -->
    <div id="home">
        <header class="appheader navbar">
        	<div class="mark">Home.vue</div>
		    <div class="d-flex width100">
		      <div class="bd-highlight w1">
		        <router-link class="navbar-brand" to="/home" tag="a">Samen Fris</router-link>
		      </div>
		      <div class="container w2">
		        
		        <ul v-if="!notForHome()" class="main-menu" >
		        	
					
					<router-link 
            :to="{path: '/tijdslijn/' + first}"
            tag="li"
            :class="{ 'active': isTijdslijn }" exact><a>Tijdslijn</a>
          </router-link>

          <!--<router-link 
            :to="{path: '/lesmateriaal/' }"
            tag="li"
            :class="{ 'active': isLesmateriaal }" exact><a>Lesmateriaal</a>
          </router-link>

          <router-link to="/lesmateriaal" tag="li" active-class="active"><a>Lesmateriaal</a></router-link>-->
          

          <router-link 
            :to="{path: '/lesmateriaal/'+viewedClassType }"
            tag="li"
            active-class="active" exact><a>Lesmateriaal</a>
          </router-link>

          
		        </ul>

                
          

		            
		      </div>
		      <div class="ml-auto  w3">
		        <ul class="nav navbar-nav">          
		          <li  id="acount-info" class="nav-item dropdown ml-auto">
		            <a class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
		              <span id="display-name">{{ userDisplayNameF }}</span><img id="my-avatar" class="img-avatar" src="/dist/img/avatars/logout.png" >
		            </a>
		            
						<div class="dropdown-menu dropdown-menu-right logoutbtn">
						  <button class="dropdown-item" @click="logout">Log out</button>
						</div>
		            
		          </li>
		        </ul>
		      </div>
		    </div>            
  		</header>

		<div class="container-fluid head-name">
		    <div class="d-flex justify-content-between bd-highlight mb-3 w100">
		        <div class="p-2 bd-highlight">
		              <h1 id="main-name">{{ userDisplayNameF }}</h1>
		        </div>
		        <div class="p-2 bd-highlight">
		            <div class="container">

		            	<ul class="klass-menu" v-if="!notForHomeAndMat()">
				            <router-link  v-for="(item, index) of itemsh" v-bind:key="item.id"
				            	tag="li" 
				            	:to="{path: '/tijdslijn/' + item.id}"
				            	:class="{'active':$route.id == item.id, 'active':($route.name == 'pageklass' )}	"
				            	><a>{{ item.title.rendered }}</a></router-link>
				            	<router-link  tag="li"  to="/home" class="edit"><a></a></router-link>		            
		        		</ul>

		        		<!--<ul class="klass-menu" v-if="isMat()">
				            <router-link  tag="li"  to="/lesmateriaal/praktisch"><a>Praktisch</a></router-link>
				            <router-link  tag="li"  to="/lesmateriaal/theoretisch"><a>Theoretisch</a></router-link>		            
		        		</ul>-->

		        	

	            	</div>
	          	</div>
	          <div class="p-2 bd-highlight"></div>
	        </div>
	    </div>  

		<transition name="slide" mode="out-in">                        
	            <router-view />
	    </transition>

	</div>
</template>

    <script>
    	import Vue from 'vue'
  

    export default {
    	name: 'Home',
    	

        data(){
            return {
            	getHeightOfApp: { },
            	itemsh:[],
            	item:'',
            	authorIdVue: localStorage.getItem("userID"),
                parentIDVar: localStorage.getItem("parentID"),
            	hostname: Vue.prototype.$hostname,
            	upd1: localStorage.getItem("numberOfClasses"),
            	upd2:'',
            	nyc:0,
            	first:'',
            	viewedClassType: 'praktisch',

            	get tokenF() {
                  return localStorage.getItem('token') || 0 ;
                },
                get roleF() {
                  return localStorage.getItem('role') || 0 ;
                },
                get userDisplayNameF(){
                    return localStorage.getItem('userNiceName') || 0 ;
                },
                /*get currentViewedClassType(){
                    return localStorage.getItem('classType') || 0 ;
                },*/
                editedClass: localStorage.getItem("changedName"),
                editedClass2:''
                
            }
        },



        created() {
        	this.fetchData();
        	this.getFirstClass();
        	//console.log('created from home');

        	setTimeout(()=>{ 
			    this.viewedClassType = localStorage.getItem('classType');
           		console.log('on load classType = '+localStorage.getItem('classType'));
			},1000);
    	},


        mounted () {
  		    this.matchHeight();
  		    this.todos = Number(localStorage.getItem('numberOfClasses'));
  		},


		updated() {
		  	this.upd2 = localStorage.getItem('numberOfClasses');
		  	this.editedClass2 = localStorage.getItem("changedName");
		  	if ((this.upd2!=this.upd1) || (this.editedClass !=this.editedClass2)) {		  	
		  		//console.log('ZMENA');		  		
		  		this.fetchData();
		  		this.upd1=this.upd2;
		  		this.editedClass =this.editedClass2
		  	}


		},

  		computed: {
		  isTijdslijn() {
		    return this.$route.name === 'page2' || this.$route.name === 'pageklass' || this.$route.name === 'pageklassdefault';
		  },
		  isKlassDetail(){
		  	return this.$route.id === 'page2' || this.$route.name === 'pageklass';
		  },
		  isLesmateriaal(){
		  	this.$route.name === 'praktisch' || this.$route.name === 'theoretisch'
		  	
		  },
		 
		},







		watch: {
	        nyc: {
	          handler() {
	            localStorage.getItem('numberOfClasses');

	          },
	          deep: true,
	        },
	        


	        '$route' (to, from) {
		        if(to !== from ) {
		         

			        setTimeout(()=>{ 
			         //this.currentViewedClassType(); 
			         this.viewedClassType = localStorage.getItem('classType');

	            		//console.log('watch classType = '+localStorage.getItem('classType'));
					},1000);

		          
                    
               


		          
		        }
      }

      	},





		

        
        
        methods:{


        	
      	 currentViewedClassType(){
                    var classType =  localStorage.getItem('classType');
                    //console.log('classType changed to = '+classType);
                    return classType;
                },

        	checkClassesChange(){
        		if (localStorage.getItem('numberOfClasses')) {

        		}
        	},
          
           logout() {
		    [
		      "token",
		      "userDisplayName",
		      "userNiceName",    // <- was left behind before
		      "role",
		      "userID",
		      "parentID",
		      "numberOfLicences",
		      "numberOfClasses",
		      "teacherEmail"
		    ].forEach(k => localStorage.removeItem(k));

		    this.$emit("authenticated", false);   // notify parent, if listening
		    this.$router.replace({ name: "login" }).catch(() => {}); // go to login
		  },

          notForHomeAndMat(){///triedy
	      	if ((this.$router.history.current["path"] == "/home")  || (this.$router.history.current["path"] == "/home/") || (this.$router.history.current["path"] == "/lesmateriaal")  || (this.$router.history.current["path"] == "/lesmateriaal/") || (this.$router.history.current["path"] == "/lesmateriaal/praktisch") || (this.$router.history.current["path"] == "/lesmateriaal/praktisch/") || (this.$router.history.current["path"] == "/lesmateriaal/theoretisch") || (this.$router.history.current["path"] == "/lesmateriaal/theoretisch/")   ) {
	      		return true;
	      	}
          },

          notForHome() {
	      	if ((this.$router.history.current["path"] == "/home")  || (this.$router.history.current["path"] == "/home/") ) {
	      		return true;
	      	}
	      },

	      notForHomeAndLes(){//mater
	      	if ((this.$router.history.current["path"] == "/home")  || (this.$router.history.current["path"] == "/home/") || (this.$router.history.current["path"] == "/tijdslijn")  || (this.$router.history.current["path"] == "/tijdslijn/")) {
	      		return true;
	      	}
	      },
	      isMat(){///triedy
	      	if ( (this.$router.history.current["path"] == "/lesmateriaal")  || (this.$router.history.current["path"] == "/lesmateriaal/") || (this.$router.history.current["path"] == "/lesmateriaal/praktisch") || (this.$router.history.current["path"] == "/lesmateriaal/praktisch/") || (this.$router.history.current["path"] == "/lesmateriaal/theoretisch") || (this.$router.history.current["path"] == "/lesmateriaal/theoretisch/")   ) {
	      		return true;
	      	}
          },

	      matchHeight () {
          
	          var heightString = $('#componentBox').height();
	          $('.nav-side').height(heightString);  





	        },

			fetchData() {
			  const self = this;

			  
			 

			    self.axios
			    	.get(
			          //`https://samenfris.nl/wp/wp-json/wp/v2/classes`,
			           `${Vue.prototype.$hostname}/wp/wp-json/wp/v2/classes`,
			          {
			            params: {  author: self.authorIdVue, per_page: 100,},
						headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
			          }
			        )



			    .then((response) => {
			      self.itemsh = response.data; // Store the received data in the itemsh property
			    })
			    .catch((error) => {
			      console.error("Error fetching data in fetchData():", error); // Log and handle errors
			    });
			},


	        getFirstClass() {
			  const self = this;

			  

			  self.axios
			    .get(
			    	//`https://samenfris.nl/wp/wp-json/wp/v2/classes`,
			    	`${Vue.prototype.$hostname}/wp/wp-json/wp/v2/classes`, 
				    	{
				    	 params: {  author: self.authorIdVue, orderby: "id", order: "desc",},
				    	 headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
				    	}
			    	)
			    .then((response) => {
			      if (response.data && response.data.length > 0) {
			        self.first = response.data[0].id; // Assign the first class ID
			      } else {
			        console.warn("No classes found for the given author in getFirstClass()");
			      }
			    })
			    .catch((error) => {
			      console.error("Error fetching data in getFirstClass():", error); // Log and handle errors
			    });
			},
          
          


            
        }
    }
</script>
<style lang="scss">
	.dropdown-menu.logoutbtn{
		position: absolute;
		padding: 0;
	}

	ul.main-menu{
		list-style-type: none;
		margin:34px 0 0 0;
		padding: 0;
		position: relative;
		li{
			float: left;
			position: relative;
			padding: 0;
			margin: 0 20px 0 0;
			&.active{
				a{
					box-shadow: 0 7px 0 0 #067b7f;
  					background-color: #2dccd2;
  					border: solid 3px #2dccd2;
  					&:hover{
  						box-shadow: 0 7px 0 0 #067b7f;
  						background-color: #2dccd2;
  						border: solid 3px #2dccd2;
  					}
				}
			}
			a{
				font-family: 'Cabin', sans-serif;
				font-size: 25px;
				line-height: 1.25;
				font-weight: 700;
				color: #000000;
				display: inline-block;
				padding: 4px 0 4px 0;
				width: 190px;
				text-align: center;
				border-radius: 45px;
  				border: solid 3px #000000;
  				text-decoration: none;
  				transition: all 0.3s;
  				&:hover{
  					color: #fff;
  					background-color: #000;
  					
  				}

			}
			

		}
	}


	ul.klass-menu{
		list-style-type: none;
		margin:24px 0 0 0;
		padding: 0;
		position: relative;
		li{
			float: left;
			position: relative;
			padding: 0;
			margin: 0 20px 18px 0;
			&.router-link-active{
				a{
					box-shadow: 0 7px 0 0 #009355;
  					background-color: #01bf6f;
  					border: solid 3px #01bf6f;
  					color: #fff;
  					&:hover{
  						box-shadow: 0 7px 0 0 #009355;
  						background-color: #01bf6f;
  						border: solid 3px #01bf6f;
  						color: #fff;
  					}
				}
			}
			a{
				font-family: 'Cabin', sans-serif;
				font-size: 25px;
				line-height: 1.25;
				font-weight: 700;
				color: #000000;
				display: inline-block;
				padding: 4px 0 4px 0;
				width: 190px;
				text-align: center;
				border-radius: 45px;
  				border: solid 3px #000000;
  				text-decoration: none;
  				transition: all 0.3s;
  				background-color: #fff;
  				&:hover{
  					background-color: #000;
  					color: #fff;
  					
  				}
			}
			&.edit{
				a{
					background-image: url(../img/icon-edit.png);
					background-position: 50%;
					background-repeat: no-repeat;
					padding: 19px;
					&:hover{
						background-image: url(../img/icon-edit-hover.png);
					}
				}
			}

		}
	}
</style>






